import { BaseActivityEvent } from './BaseActivityEvent'
import { ReactComponent as Icon } from './icons/deleteLayer.svg'
import { Actor } from './Actor'
import { ActivityEventPosition, LayerDeletedEvent } from './Types'

interface Props extends ActivityEventPosition {
  event: LayerDeletedEvent
}

const LayerDeleted = ({ event, ...props }: Props) => {
  const { user, data, layer } = event
  const isCurrentLayer = data.deleted_layer_id === layer.id

  const text = isCurrentLayer ? 'deleted this layer.' : `deleted ${data.deleted_layer_name}`

  return (
    <BaseActivityEvent
      {...props}
      icon={<Icon />}
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> {text}
        </>
      }
    />
  )
}

export { LayerDeleted }
